<div class="circularProgress">
  <svg>
    <circle cx="60" cy="60" r="60"></circle>
    <circle cx="60" cy="60" r="60" class="progressLine" [ngStyle]="{ 'stroke-dashoffset': 'calc(380 - (380 * ' + progress + ') / 100)' }"></circle>
  </svg>
  <div class="number">
    <h2>{{progress}}<span>%</span></h2>
  </div>
</div>
